function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M165,60 L212,60 C218.627417,60 224,65.372583 224,72 L224,119 C224,125.627417 218.627417,131 212,131 L153,131 L153,72 C153,65.372583 158.372583,60 165,60 Z",
  fill: "#E2FCA4"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#DEDEDE",
  points: "177 150 239 150 239 158 177 158"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#DEDEDE",
  points: "177 166 265 166 265 174 177 174"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#DEDEDE",
  points: "177 182 213 182 213 190 177 190"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M190.565737,102.156809 C190.565737,101.297111 190.633466,100.643741 190.73506,100.162311 C190.938247,99.2338377 192.123506,97.9614856 193.105578,97.2393398 C195.476096,95.4855571 197,93.7661623 197,90.8431912 C197,86.4759285 192.936255,84 188.432271,84 C183.691235,84 180.237052,87.1980743 180,91.8404402 L184.605578,92.1155433 C184.910359,89.5020633 186.26494,87.8170564 188.635458,87.8170564 C190.768924,87.8170564 192.089641,89.0550206 192.089641,91.0495186 C192.089641,92.9064649 190.498008,93.9724897 189.346614,94.9009629 C188.330677,95.7262724 187.517928,96.5171939 187.043825,97.3768913 C186.535857,98.2709766 186.163347,99.3713893 186.163347,100.815681 L186.163347,102.156809 L190.565737,102.156809 Z M190.904382,109 L190.904382,104.013755 L185.926295,104.013755 L185.926295,109 L190.904382,109 Z",
  fill: "#073C50",
  fillRule: "nonzero"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  fill: "transparent",
  stroke: "#073C50",
  cx: 153,
  cy: 125,
  r: 64.5
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M47,131 L153,131 L153,178 C153,184.627417 147.627417,190 141,190 L47,190 C40.372583,190 35,184.627417 35,178 L35,143 C35,136.372583 40.372583,131 47,131 Z",
  fill: "#073C50"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "103.916667 155.309876 100.881512 152.166667 90.8172578 162.589078 86.1184883 157.723093 83.0833333 160.866303 90.8172578 168.833333"
});

var SvgArtSubmitProposal = function SvgArtSubmitProposal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 300 250",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArtSubmitProposal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/art-submit-proposal.1c69ce65.svg";
export { ForwardRef as ReactComponent };